import { create } from 'zustand';
import i18n from 'i18n';
import { AccountsApi, BlockCardRequest, RestApiError, StatusCodeEnum } from '@shared/api';

interface UseBlockCardStore {
  loading: boolean;
  error?: string | null;
  success: boolean | null;
  block: (request: BlockCardRequest) => void;
  clear: () => void;
}

export const useBlockCardStore = create<UseBlockCardStore>((set) => ({
  loading: false,
  error: null,
  success: null,

  block: async (request: BlockCardRequest) => {
    try {
      set({ loading: true, error: null, success: null });
      await AccountsApi.blockCard(request);
      set({ loading: false, success: true });
      return { loading: false, success: true };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Wrong password';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_BAD_REQUEST:
          if (Array.isArray(restError?.data)) errorMessage = restError?.data?.join('\n');
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, error, success: false });
      return { loading: false, error, success: false };
    }
  },

  clear: () => set({ loading: false, error: null, success: null }),
}));
